<template>
  <v-container>
    <PageHeader :title="pageTitle" :path="goToPath" />
    <v-card class="elevation-1">
      <v-card-text class="py-0 my-0">
        <v-row>
          <v-col cols="12" class="mx-0 px-0">
            <v-data-table
              :headers="headers"
              :items="financiadores"
              class="pa-3"
              :mobile="isMobile"
              :hide-default-header="isMobile"
              :search="search"
              :loading="isLoadingTable"
            >
              <template v-slot:top>
                <v-toolbar flat style="background-color: transparent">
                  <v-row>
                    <v-col cols="8" align-self="center" class="buscador pl-0">
                      <v-text-field
                        v-show="financiadores?.length > 0"
                        v-model="search"
                        :append-icon="searchIcon"
                        label="Buscar"
                        single-line
                        variant="underlined"
                        hide-details
                        clearable
                        class="ml-5"
                        style="width: auto"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      class="d-flex align-center"
                      :class="isMobile ? 'mt-3' : ''"
                      style="justify-content: end"
                      cols="4"
                      v-if="permisosFinanciadores.canCreate"
                    >
                      <v-btn
                        color="primary"
                        variant="flat"
                        @click="openModalEdit()"
                      >
                        Nuevo
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-toolbar>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip
                  text="Gestión de farmacias"
                  location="left"
                  v-if="permisosFinanciadores.canGoToFarmacias"
                >
                  <template v-slot:activator="{ props }">
                    <v-icon
                      size="20"
                      v-bind="props"
                      @click="goToGestionFarmacias(item.financiadorId)"
                      id="v-icon-gestion-farmacias"
                    >
                      {{ drugstoreIcon }}
                    </v-icon>
                  </template>
                </v-tooltip>
                <v-tooltip
                  text="Gestión de usuarios emisores"
                  location="left"
                  v-if="permisosFinanciadores.canGoToUsuariosEmisores"
                >
                  <template v-slot:activator="{ props }">
                    <v-icon
                      size="20"
                      v-bind="props"
                      @click="goToGestionUsuariosEmisores(item.financiadorId)"
                      id="v-icon-gestion-usuarios-emisores"
                    >
                      {{ detailsUserIcon }}
                    </v-icon>
                  </template>
                </v-tooltip>
                <v-tooltip
                  text="Gestionar entidades emisoras"
                  location="left"
                  v-if="permisosFinanciadores.canGoToEntidadesEmisores"
                >
                  <template v-slot:activator="{ props }">
                    <v-icon
                      size="20"
                      v-bind="props"
                      @click="openEmtidadesEmisorasDialog(item)"
                      id="v-icon-entidades-emisores"
                    >
                      {{ "mdi-hospital-building" }}
                    </v-icon>
                  </template>
                </v-tooltip>

                <!--
                  <v-tooltip
                  text="Ver tipos prestadores"
                  location="left"
                  v-if="false"
                  >
                  <template v-slot:activator="{ props }">
                    <v-icon
                    size="20"
                    v-bind="props"
                    @click="openVerTipoPrestadoresDialog(item)"
                    id="v-icon-ver-prestadores"
                    >
                    {{ accountBoxMultipleIcon }}
                  </v-icon>
                </template>
              </v-tooltip>
              -->
                <v-tooltip
                  location="left"
                  v-if="permisosFinanciadores.canSeeReport"
                >
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      size="20"
                      @click="openReporteDialog(item)"
                    >
                      {{ "mdi-text-box-search" }}
                    </v-icon>
                  </template>
                  <span>Ver reportes financiador</span>
                </v-tooltip>
                <v-tooltip
                  location="left"
                  v-if="permisosFinanciadores.canMapTiposDocumento"
                >
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      size="20"
                      @click="openMapeoTiposDoc(item)"
                    >
                      {{ 'mdi-file-compare' }}
                    </v-icon>
                  </template>
                  <span>Mapear tipos de documento</span>
                </v-tooltip>
                <v-tooltip location="left" v-if="permisosFinanciadores.canEdit">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      size="20"
                      @click="openModalEdit(item)"
                    >
                      {{ editIcon }}
                    </v-icon>
                  </template>
                  <span>Editar financiador</span>
                </v-tooltip>
                <v-tooltip
                  location="left"
                  v-if="permisosFinanciadores.canDelete"
                >
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      size="20"
                      @click="openDeleteDialog(item.financiadorId)"
                    >
                      {{ deleteIcon }}
                    </v-icon>
                  </template>
                  <span>Eliminar financiador</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
  <v-dialog
    v-if="isOpenModalMapeoTiposDoc"
    v-model="isOpenModalMapeoTiposDoc"
    :max-width="isMobile ? '95%' : '60%'"
    persistent
  >
    <TiposDocMapeoModal
      :financiadorId="financiadorItem?.financiadorId"
      @close="closeMapeoTiposDoc"
      @saved="closeMapeoTiposDoc(true)"
    />
  </v-dialog>
  <v-dialog
    :max-width="isMobile ? '95%' : '70%'"
    v-model="dialogVerTipoPrestadores"
    persistent
  >
    <VerTiposPrestadores
      :financiadorItem="financiadorItem"
      @cerrarVerTipoPrestadoresDialog="closeVerTipoPrestadoresDialog"
      @reloadFinanciadores="loadFinanciadores"
    />
  </v-dialog>
  <v-dialog
    v-if="isOpenModalEdit"
    v-model="isOpenModalEdit"
    :max-width="isMobile ? '95%' : '60%'"
    persistent
  >
    <EditFinanciadores
      :financiadorItem="financiadorItem"
      @closeAndReload="closeAndReload"
    />
  </v-dialog>
  <v-dialog
    v-if="isOpenModalReport"
    v-model="isOpenModalReport"
    :max-width="isMobile ? '95%' : '45%'"
    persistent
  >
    <ReportFinanciadores
      :financiadorProp="financiadorItem"
      @closeDialog="closeAndReload"
    />
  </v-dialog>
  <v-dialog
    :max-width="isMobile ? '95%' : '30%'"
    v-model="dialogDelete"
    persistent
  >
    <DeleteDialog
      v-if="dialogDelete"
      title="financiador"
      :subtitle="deleteSubtitle"
      :isLoading="isLoadingDelete"
      @eliminar-confirmado="confirmDelete"
      @eliminar-cancelado="closeDeleteDialog"
    />
  </v-dialog>
</template>

<script>
import EditFinanciadores from "@/components/modules/financiadores/EditFinanciadores.vue";
import ReportFinanciadores from "@/components/modules/financiadores/ReportFinanciadores.vue";
import TiposDocMapeoModal from "@/components/modules/financiadores/TiposDocMapeoModal.vue";
import VerTiposPrestadores from "@/components/modules/financiadores/VerTiposPrestadores.vue";
import enums from "@/utils/enums/index";
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/layout/PageHeader.vue";
import DeleteDialog from "@/components/shared/DeleteDialog.vue";
export default {
  name: "FinanciadoresView",
  components: {
    EditFinanciadores,
    VerTiposPrestadores,
    PageHeader,
    DeleteDialog,
    ReportFinanciadores,
    TiposDocMapeoModal,
  },
  data() {
    return {
      deleteSubtitle: enums.messages.FINANCIADORES_DELETE_SUBTITLE,
      isOpenModalEdit: false,
      isOpenModalReport: false,
      isOpenModalMapeoTiposDoc: false,
      dialogVerTipoPrestadores: false,
      dialogDelete: false,
      search: "",
      financiadorItem: null,
      pageTitle: enums.permises.FINANCIADORES.name,
      goToPath: enums.permises.HOME.path,
      searchIcon: enums.icons.SEARCH_ICON,
      accountBoxMultipleIcon: enums.icons.ACCOUNT_BOX_MULTIPLE,
      drugstoreIcon: enums.icons.DRUGSTORE_ICON,
      detailsUserIcon: enums.icons.DETAILS_USER,
      editIcon: enums.icons.EDIT_ICON,
      deleteIcon: enums.icons.DELETE_ICON,
      financiadorToDelete: null,
      isLoadingTable: false,
      isLoadingDelete: false,
      headers: [
        {
          title: "Número",
          key: "financiadorId",
          sortable: false,
        },
        {
          title: "Nombre",
          key: "financiadorNom",
          sortable: false,
        },
        {
          title: "Código",
          key: "financiadorCodigo",
          sortable: false,
        },
        {
          title: "URL",
          key: "financiadorUrl",
          sortable: false,
        },
        {
          title: "Acciones",
          key: "actions",
          sortable: false,
          align: "end",
        },
      ],
      financiadores: [],
    };
  },
  computed: {
    ...mapGetters({
      permisos: "menu/permisos",
      isMobile: "menu/isMobile",
    }),
    permisosFinanciadores() {
      let canCreate = false;
      let canEdit = false;
      let canDelete = false;
      let canGoToUsuariosEmisores = false;
      let canGoToFarmacias = false;
      let canGoToEntidadesEmisores = false;
      let canVerTiposPrestadores = false;
      let canSeeReport = false;
      let canMapTiposDocumento = false;

      if (this.permisos != null) {
        this.permisos.forEach((x) => {
          switch (x.permisoCodigo) {
            case enums.permises.CREAR_FINANCIADOR.code:
              canCreate = true;
              break;
            case enums.permises.EDITAR_FINANCIADOR.code:
              canEdit = true;
              break;
            case enums.permises.ELIMINAR_FINANCIADOR.code:
              canDelete = true;
              break;
            case enums.permises.VER_TIPOS_PRESTADORES.code:
              canVerTiposPrestadores = true;
              break;
            case enums.permises.GESTION_USUARIOS_EMISORES.code:
              canGoToUsuariosEmisores = true;
              break;
            case enums.permises.EMISORES.code:
              canGoToEntidadesEmisores = true;
              break;
            case enums.permises.VER_REPORTES_CONFIGURACION.code:
              canSeeReport = true;
              break;    
            case enums.permises.MAPEO_TIPOS_DOCUMENTOS.code:
              canMapTiposDocumento = true;
              break;
            case enums.permises.GESTION_FARMACIAS.code:
              canGoToFarmacias = true;
              break;
            default:
              break;
          }
        });
      }
      return {
        canCreate,
        canEdit,
        canDelete,
        canVerTiposPrestadores,
        canGoToUsuariosEmisores,
        canGoToEntidadesEmisores,
        canSeeReport,
        canGoToFarmacias,
        canMapTiposDocumento,
      };
    },
  },
  created() {
    this.updateFinanciadorId(null); // Updeteo el financiadorId en el state para limpiar el dato y que no quede dando vueltas
    this.updateFinanciadorNom(null); // Updeteo el financiadorNom en el state para limpiar el dato y que no quede dando vueltas
    this.loadFinanciadores();
    this.$store.dispatch("user/changeAppLoading", {
      status: false,
      text: "",
    });
  },
  methods: {
    ...mapActions({
      updateFinanciadorId: "financiador/updateFinanciadorId",
      updateFinanciadorNom: "financiador/updateFinanciadorNom",
      updateFinanciadorUsaGecros: "financiador/updateFinanciadorUsaGecros",
      getFinanciadores: "financiador/getFinanciadores",
      deleteFinanciador: "financiador/deleteFinanciador",
      setAlert: "user/setAlert",
    }),
    async loadFinanciadores() {
      this.isLoadingTable = true;
      const response = await this.getFinanciadores();
      this.financiadores = response;
      this.isLoadingTable = false;
    },
    async openReporteDialog(financiadorId) {
      this.isOpenModalReport = true;
      this.financiadorItem = financiadorId;
    },
    openModalEdit(item) {
      this.isOpenModalEdit = true;
      this.financiadorItem = item;
    },
    openVerTipoPrestadoresDialog(item) {
      this.dialogVerTipoPrestadores = true;
      this.financiadorItem = item;
    },
    closeVerTipoPrestadoresDialog() {
      this.dialogVerTipoPrestadores = false;
      this.loadFinanciadores();
    },
    closeAndReload(reload) {
      this.isOpenModalReport = this.isOpenModalEdit = false;
      if (reload) {
        this.loadFinanciadores();
      }
    },
    async confirmDelete() {
      this.isLoadingDelete = true;
      try {
        const response = await this.deleteFinanciador(this.financiadorToDelete);
        if (response?.status === 200) {
          this.setAlert({ type: "success", message: "Eliminado con éxito" });
          this.dialogDelete = false;
          this.loadFinanciadores();
        }
      } catch (error) {
        console.error(error);
      }
      this.isLoadingDelete = false;
    },
    openDeleteDialog(id) {
      this.dialogDelete = true;
      this.financiadorToDelete = id;
    },
    closeDeleteDialog() {
      this.dialogDelete = false;
    },
    openEmtidadesEmisorasDialog(item) {
      this.updateFinanciadorId(item.financiadorId);
      this.updateFinanciadorNom(item.financiadorNom);
      this.$router.push({
        name: "Entidades Emisoras",
      });
      this.$store.dispatch("user/changeAppLoading", {
        status: true,
        text: "",
      });
    },
    goToGestionUsuariosEmisores(id) {
      const financiador = this.financiadores.find(
        (f) => f.financiadorId === id
      );
      this.updateFinanciadorId(id);
      this.updateFinanciadorNom(financiador?.financiadorNom);
      this.updateFinanciadorUsaGecros(
        financiador?.financiadorUsaGecros ?? false
      );
      this.$router.push({
        name: "GestionUsuariosEmisores",
      });
      this.$store.dispatch("user/changeAppLoading", {
        status: true,
        text: "",
      });
    },
    goToGestionFarmacias(id) {
      const financiador = this.financiadores.find(
        (f) => f.financiadorId === id
      );
      this.updateFinanciadorId(id);
      this.updateFinanciadorNom(financiador?.financiadorNom);
      this.$router.push({
        name: "GestionFarmacias",
      });
      this.$store.dispatch("user/changeAppLoading", {
        status: true,
        text: "",
      });
    },
    openMapeoTiposDoc(item) {
      this.isOpenModalMapeoTiposDoc = true;
      this.financiadorItem = item;
    },
    closeMapeoTiposDoc(reload) {
      this.isOpenModalMapeoTiposDoc = false;
      if (reload) this.loadFinanciadores();
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .buscador {
    width: 70%;
    flex: none;
  }
}
.no-upper-case {
  text-transform: none;
}
</style>
